function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "22",
  viewBox: "0 0 20 22"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.904 19.756a1 1 0 110 2h-11a1 1 0 010-2h11zM11.994.44l2.03 1.37a2.575 2.575 0 01.695 3.575L6.641 17.362l-4.827 2.314a1.267 1.267 0 01-1.811-1.222l.337-5.342L8.42 1.135A2.575 2.575 0 0111.993.44zM7.597 5.928L2.302 13.78l-.224 3.552 3.209-1.539 5.32-7.887a1 1 0 01-.264-.127L7.598 5.928zm.746-1.106a.333.333 0 01-.323.576l-.05-.026v.003l2.745 1.852a.333.333 0 01-.126-.395l.036-.068a.333.333 0 01.394-.126l.069.036-2.745-1.852zm1.733-2.568L8.716 4.27l2.745 1.851a1 1 0 01.217.197l1.383-2.051a.575.575 0 00-.155-.798l-2.03-1.37a.575.575 0 00-.8.155z"
}));